import React from 'react';

import type { FlagProps } from '../src/types';

const FlagPs = ({ className, testID }: FlagProps) => (
  <svg
    width={20}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testID}
    className={className}
    aria-hidden="true"
  >
    <mask
      id="prefix__a"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={15}
    >
      <path fill="#fff" d="M0 0h20v15H0z" />
    </mask>
    <g mask="url(#prefix__a)" fillRule="evenodd" clipRule="evenodd">
      <path d="M0 0h20v15H0V0z" fill="#F7FCFF" />
      <path d="M0 0v5h20V0H0z" fill="#5EAA22" />
      <path d="M0 10v5h20v-5H0z" fill="#272727" />
      <path d="M0 1.25 10 7.5 0 13.75V1.25z" fill="#E31D1C" />
    </g>
  </svg>
);

export default FlagPs;
